import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isSeoSuggestAvailable } from './seo/isSeoSuggestAvailable';

export const seoSuggestionLabel: TComputedPropMapper<string | undefined> = ({
  offer,
  jsonQuery,
  suggestionDistancesSeoText,
}) => {
  return isSeoSuggestAvailable(offer, jsonQuery) ? suggestionDistancesSeoText : undefined;
};
